import { Box, Divider } from '@mui/material';

import { DrawerFormActionSummary } from '../../../common/components';
import { materialMoney } from '../../../utils/materialDisplay';
import { KPI_LABELS, MATERIAL_TEXTS } from '../constants/materialDashboardConstants';

/**
 * Indicadores en una franja sin recuadros; si falta cobertura, el subtotal conocido va en el
 * tooltip.
 * @param {Object} props
 * @param {Object} [props.totals] Totales del resumen.
 * @param {boolean} props.isLoading Resumen en carga.
 * @returns {JSX.Element}
 */
const MaterialDashboardIndicators = ({ totals, isLoading }) => (
  <Box
    sx={{
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: 2.5,
      px: 2.5,
      py: 1.5,
      backgroundColor: 'background.paper',
      borderBottom: 1,
      borderColor: 'divider',
    }}
  >
    {Object.entries(KPI_LABELS).map(([key, label], index) => {
      const value = totals?.[key];
      const knownSubtotal =
        !isLoading && totals && value == null
          ? `${MATERIAL_TEXTS.knownSubtotal}: ${materialMoney(totals[`${key}_known`])}`
          : undefined;
      return (
        <Box key={key} sx={{ display: 'flex', alignItems: 'center', gap: 2.5, minWidth: 0 }}>
          {index > 0 && <Divider orientation="vertical" flexItem />}
          <Box title={knownSubtotal}>
            <DrawerFormActionSummary
              label={label}
              value={isLoading ? MATERIAL_TEXTS.loading : materialMoney(value)}
            />
          </Box>
        </Box>
      );
    })}
  </Box>
);

export default MaterialDashboardIndicators;
